var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xE5\xAF\x83\xE2\x91\xB8\xE2\x94\x81_\xEF\xA7\x8F\xE2\x91\xA4\xEB\xB1\xB6",
    clipPath: "url(#clip0_53_3164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 13C25 15.7296 19.4303 16.3523 17.6419 18.1419C15.8535 19.9303 15.2296 25.5 12.5 25.5C9.77042 25.5 9.14773 19.9303 7.35811 18.1419C5.56968 16.3535 0 15.7296 0 13C0 10.2704 5.56968 9.64773 7.35811 7.85811C9.14773 6.06968 9.77042 0.5 12.5 0.5C15.2296 0.5 15.8523 6.06968 17.6419 7.85811C19.4303 9.64654 25 10.2704 25 13Z",
    fill: "#5E42E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_3164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColored);
export default __webpack_public_path__ + "static/media/icon_colored.4c62618509db9c34d3b7937009741358.svg";
export { ForwardRef as ReactComponent };